/*
 * Copyright (c) 2016-2023 VMware, Inc. All Rights Reserved.
 * This software is released under MIT license.
 * The full license information can be found in LICENSE in the root directory of this project.
 */
import { camelCaseToKebabCase } from './string.js';
class BrowserFeatures {
    constructor() {
        this.supports = {
            js: true,
        };
        if (!document.body.hasAttribute('cds-supports') || document.body.getAttribute('cds-supports') === 'no-js') {
            const supports = camelCaseToKebabCase(Object.keys(this.supports).reduce((prev, next) => `${prev} ${this.supports[next] ? next : `no-${next}`}`, '')).trim();
            document.body.setAttribute('cds-supports', supports);
        }
    }
}
export const browserFeatures = new BrowserFeatures();
